import Alert from './alert';
import Badge from './badge';
import Breadcrumb from './breadcrumb';
import Button from './button';
import ButtonGroup from './button-group';
import ButtonToolbar from './button-toolbar';
import InputGroup from './input-group';
import Card from './card';
import Carousel from './carousel';
import Layout from './layout';
import Collapse from './collapse';
import Dropdown from './dropdown';
import Embed from './embed';
import Form from './form';
import FormGroup from './form-group';
import FormCheckbox from './form-checkbox';
import FormRadio from './form-radio';
import FormInput from './form-input';
import FormTextarea from './form-textarea';
import FormFile from './form-file';
import FormSelect from './form-select';
import Image from './image';
import Jumbotron from './jumbotron';
import Link from './link';
import ListGroup from './list-group';
import Media from './media';
import Modal from './modal';
import Nav from './nav';
import Navbar from './navbar';
import Pagination from './pagination';
import PaginationNav from './pagination-nav';
import Popover from './popover';
import Progress from './progress';
import Table from './table';
import Tabs from './tabs';
import Tooltip from './tooltip';

export { Alert, Badge, Breadcrumb, Button, ButtonToolbar, ButtonGroup, Card, Carousel, Collapse, Dropdown, Embed, Form, FormGroup, FormInput, FormTextarea, FormFile, FormCheckbox, FormRadio, FormSelect, Image, InputGroup, Jumbotron, Layout, Link, ListGroup, Media, Modal, Nav, Navbar, Pagination, PaginationNav, Popover, Progress, Table, Tabs, Tooltip };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/components/index.js
// module id = 1489
// module chunks = 3